import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Typography,
  Button,
  Alert,
} from "@mui/material";

const ResetPassword: React.FC = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    if (!password || password.length < 6) {
      setError("Wachtwoord moet minstens 6 karakters zijn.");
      return;
    }

    if (password !== confirm) {
      setError("Wachtwoorden komen niet overeen.");
      return;
    }

    setError(null);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/auth/reset-password/${token}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ password }),
        }
      );

      if (!response.ok) throw new Error();

      setSuccess(true);

      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (err) {
      setError("Link verlopen of ongeldig.");
    }
  };

  return (
    <Box display="flex" justifyContent="center" mt={8}>
      <Card sx={{ width: 400 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Nieuw Wachtwoord
          </Typography>

          {error && <Alert severity="error">{error}</Alert>}
          {success && (
            <Alert severity="success">
              Wachtwoord succesvol aangepast! Je wordt doorgestuurd...
            </Alert>
          )}

          {!success && (
            <>
              <TextField
                fullWidth
                type="password"
                label="Nieuw wachtwoord"
                margin="normal"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <TextField
                fullWidth
                type="password"
                label="Bevestig wachtwoord"
                margin="normal"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
              />

              <Button
                fullWidth
                variant="contained"
                color="primary"
                sx={{ mt: 2 }}
                onClick={handleSubmit}
              >
                Wachtwoord Opslaan
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default ResetPassword;
